import React from "react";
import "./style/header-image.css"; // Importa il file CSS
import headerImg from "../../images/header_long_compressed.jpg";

function HeaderImageDK() {
	return (
		<div>
			<img
				src={headerImg}
				alt="Header"
				className="header-image-dk"
				width={headerImg.offsetWidth}
				height={headerImg.offsetHeight}
        effect="blur"
			/>
		</div>
	);
}

export default HeaderImageDK;
